import { Input, Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { AuthService } from "../../../services/authService";
import { PhoneNumbersService } from "../../../services/phoneNumbersService";
import { PhoneNumberModel } from "../../../models/phoneNumberModel";
import { SnotifyService } from "ng-snotify";
import { BaseComponent } from "../../base/base.component";
import { EnvService } from "../../../services/env.service";

@Component({
  selector: 'edit-agent-phone-dialog',
  templateUrl: './edit-agent-phone-dialog.component.html',
  styleUrls: ['./edit-agent-phone-dialog.component.css']
})
export class EditAgentPhoneDialogComponent extends BaseComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() phoneNumber: PhoneNumberModel;
  @Input() icmUsername: string;

  public phoneNumbers: PhoneNumberModel[];

  constructor(
    public activeModal: NgbActiveModal,
    private phoneNumbersService: PhoneNumbersService,
    public authService: AuthService,
    snotifyService: SnotifyService,
    private env: EnvService) {
    super(snotifyService, env.apiUrl);
  }

  ngOnInit() {
    this.blockUI.start();
    this.phoneNumbersService.getPhoneNumbers().subscribe(
      data => {
        this.phoneNumbers = data;
        this.blockUI.stop();
      },
      error => {
        this.showResponseError(error);
      })
  }

  public decline() {
    this.activeModal.dismiss();
  }

  public accept() {
    this.activeModal.close({
      phoneNumber: this.phoneNumber,
      icmUsername: this.icmUsername
    });
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
